import React, { FC, useCallback, useEffect } from 'react';
import { Field, FieldRenderProps, useField } from 'react-final-form';
import { useDispatch } from 'react-redux';

import Icon from 'src/common/components/IconDS22';
import InstabookEditorDayPickerModal from 'src/calendar/components/InstabookEditorDayPicker';
import { INSTABOOK_EDITOR_DATES_FIELD, INSTABOOK_TRIP_DATE_MODAL_NAME as modalName } from '../../constants';
import Svg from '../../../common/components/Svg';
import { close, open } from '../../../common/ducks/zippy';

import s from './InstabookAvailabilityDates.module.scss';
import InstabookAvailabilityDatesField from './InstabookAvailabilityDatesField';

type Props = {
  /** Should user be able to open the Date picker modal? */
  disabled: boolean;
};

const InstabookAvailabilityDates: FC<Props> = ({ disabled }) => {
  const dispatch = useDispatch();
  const {
    meta: {
      active: dateFieldActive,
    },
    input: { value },
  } = useField(INSTABOOK_EDITOR_DATES_FIELD);

  const openModal = useCallback(() => dispatch(open(modalName)), [dispatch]);
  const closeModal = useCallback(() => dispatch(close(modalName)), [dispatch]);

  useEffect(() => {
    if (dateFieldActive) {
      openModal();
    } else {
      closeModal();
    }
  }, [dateFieldActive, openModal, closeModal]);

  return (
    <div className={s.root}>
      <h2 className={s.title}>
        Availability
      </h2>
      <div className={s.card}>
        <div
          className={s.header}
        >
          <Icon id="calendar" className={s.icon} size="xl" />
          <h4 className={s.heading}>Date(s)</h4>
        </div>
        <div className={s.fieldWrapper}>
          <Svg className={s.editIcon} href="#card-edit-icon" />
          <InstabookAvailabilityDatesField fieldValue={value} />
          <Field<Date[]>
            withIcon={false}
            name={INSTABOOK_EDITOR_DATES_FIELD}
            disabled={disabled}
            shouldBeTouchedToShowError={false}
            render={(props: FieldRenderProps<Date[]>) => (
              <InstabookEditorDayPickerModal {...props} />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default InstabookAvailabilityDates;
